import { useEffect } from 'react';

const useLockBodyScroll = (isLocked: boolean): void => {
    useEffect(() => {
        const scrollTarget = document.getElementById('noScroll');
        if (!scrollTarget) return;

        if (isLocked) {
            scrollTarget.classList.add('overflow-hidden');
            scrollTarget.classList.remove('overflow-y-auto', 'overflow-x-hidden');
        } else {
            scrollTarget.classList.remove('overflow-hidden');
            scrollTarget.classList.add('overflow-y-auto', 'overflow-x-hidden');
        }

        return () => {
            scrollTarget.classList.remove('overflow-hidden');
            scrollTarget.classList.add('overflow-y-auto', 'overflow-x-hidden');
        };
    }, [isLocked]);
};

export default useLockBodyScroll;

